import React from "react";
import { useProjectResourcesRetrieval } from "@planzone/view-models";
import { Props } from "./types";
import { Resource } from "./resource";
import styles from "./styles.scss";

function ResourceList({ project }: Props) {
  const {
    projectResources,
    isRequestFailure,
    isRequestSuccess,
    isRequestPending,
    retrieveProjectResources,
  } = useProjectResourcesRetrieval(project);
  const managers = projectResources
    .filter(({ role }) => role.name === "pr_manager")
    .map(({ resource }) => resource);

  React.useEffect(() => {
    !!project.uuid &&
      !isRequestPending &&
      !isRequestFailure &&
      !isRequestSuccess &&
      retrieveProjectResources(project);
  }, [project.uuid]);

  return (
    <div className={styles.resourceList}>
      <div className={styles.resources}>
        {managers.slice(0, 2).map((resource) => (
          <Resource resource={resource} />
        ))}
        {managers.length > 2 && (
          <p className={styles.hiddenTagsNbr}>+{managers.slice(2).length}</p>
        )}
      </div>
    </div>
  );
}

export { ResourceList };
